const _ = require('./enum');
module.exports = {
  [_.BACKUP]: { id: _.BACKUP, label: 'Backup POS used' },
  [_.PROFIT_AND_LOSS]: { id: _.PROFIT_AND_LOSS, label: 'Profit and Loss' },
  [_.OTHER]: { id: _.OTHER, label: 'Other' },
};
